import type { SiteList } from "src/app/features/Site/types/SiteList";
import type { SiteDto } from "../../types/SiteDto";

export const SiteListToDto = ({ changed: _changed, parentUnitName: _parentUnitName, key: _key, ...rest }: Readonly<SiteList>): SiteDto => {
    return { ...rest };
};
